import React from 'react';
import { X } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const SizeGuideModal = ({ isOpen, onClose, sizeGuide }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="size-guide-modal">
        <DialogHeader>
          <DialogTitle className="heading-1">Event Size Guide</DialogTitle>
          <DialogDescription className="body-regular">
            Choose the perfect package for your event
          </DialogDescription>
        </DialogHeader>
        
        <div className="size-guide-grid">
          {sizeGuide.map((size) => (
            <div key={size.id} className="size-guide-card">
              <h3 className="heading-3">{size.title}</h3>
              <p className="body-large" style={{ marginTop: '12px', fontWeight: '700' }}>{size.guestCount}</p>
              <p className="body-regular" style={{ marginTop: '8px', color: 'var(--text-secondary)' }}>Duration: {size.duration}</p>
              
              <div style={{ marginTop: '24px' }}>
                <p className="body-small" style={{ fontWeight: '700', marginBottom: '8px' }}>Ideal Venues:</p>
                <ul className="venue-list">
                  {size.venues.map((venue, index) => (
                    <li key={index} className="body-small">{venue}</li>
                  ))}
                </ul>
              </div>
              
              <p className="body-regular" style={{ marginTop: '16px', fontStyle: 'italic' }}>{size.description}</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SizeGuideModal;